import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
	state: {
        app_bar_visible: true
	},
	mutations: {

	},
	actions: {
    
	}
})
